import { OtherPreferences } from "@/clients/models/OtherPreferences";
import { OtherPreferencesService } from "@/clients/services/OtherPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * Hook to update other preferences for the current user
 *
 * @returns Object containing mutation functions and state
 */
export const useUpdateOtherPreferences = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.OTHER_PREFERENCES, "update"],
    mutationFn: async (otherPreferences: OtherPreferences) => {
      const user = guardGetUserFromLocalStorage();
      return OtherPreferencesService.updateOtherPreferencesApiV1OtherPreferencesPut(
        user.id,
        otherPreferences,
      );
    },
    onSuccess: () => {
      // Invalidate other preferences query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.OTHER_PREFERENCES],
      });
    },
  });

  return {
    updateOtherPreferences: mutate,
    updateOtherPreferencesAsync: mutateAsync,
    isUpdating: isPending,
    isError,
    error,
  };
};
